export default __webpack_public_path__ + "static/covid-banner-logo-6466c73a4e33752965eb916ac8291bae.png";